import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "d-flex align-center" };
const _hoisted_2 = { class: "d-flex align-center" };
const _hoisted_3 = { class: "d-flex align-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_v_autocomplete = _resolveComponent("v-autocomplete");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_v_radio = _resolveComponent("v-radio");
    const _component_v_radio_group = _resolveComponent("v-radio-group");
    const _component_DeliveryFeeGroupSelect = _resolveComponent("DeliveryFeeGroupSelect");
    const _component_CashAutoDeductGroupSelect = _resolveComponent("CashAutoDeductGroupSelect");
    const _component_AllocatedCancelPenaltyGroupSelect = _resolveComponent("AllocatedCancelPenaltyGroupSelect");
    const _component_CardSection = _resolveComponent("CardSection");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_CardSection, {
            title: _ctx.$t(`${_ctx.lc}delivery_setting`)
        }, {
            default: _withCtx(() => [
                _createCommentVNode(" 카드 단말기 유형 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}card_device_type`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                            "item-title": "text",
                            "item-value": "value",
                            modelValue: _ctx.cardDeviceTypeComputed,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.cardDeviceTypeComputed) = $event)),
                            items: _ctx.cardDeviceTypeOptions,
                            variant: "outlined",
                            density: "compact",
                            "hide-details": "auto",
                            "menu-props": { contentClass: 'brg-select-option' }
                        }, null, 8 /* PROPS */, ["modelValue", "items"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 락타임 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}order_delay_time_second`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_autocomplete, {
                            "item-title": "text",
                            "item-value": "value",
                            modelValue: _ctx.orderDelayTimeSecondComputed,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.orderDelayTimeSecondComputed) = $event)),
                            items: _ctx.orderDelayTimeSecondTypeOptions,
                            variant: "outlined",
                            density: "compact",
                            "hide-details": "auto",
                            onBlur: _cache[2] || (_cache[2] = ($event) => (_ctx.onBlurOrderDelayTimeSecondField(_ctx.formData.orderDelayTimeSecond)))
                        }, null, 8 /* PROPS */, ["modelValue", "items"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 접수 목록 제한 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}accepted_order_view_limit_count`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_autocomplete, {
                            "item-title": "text",
                            "item-value": "value",
                            modelValue: _ctx.acceptedOrderViewLimitCountComputed,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.acceptedOrderViewLimitCountComputed) = $event)),
                            items: _ctx.acceptedOrderViewLimitCountTypeOptions,
                            variant: "outlined",
                            density: "compact",
                            "hide-details": "auto",
                            onBlur: _cache[4] || (_cache[4] = ($event) => (_ctx.onBlurAcceptedOrderViewLimitCountField(_ctx.formData.acceptedOrderViewLimitCount)))
                        }, null, 8 /* PROPS */, ["modelValue", "items"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 배차 제한잔액 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}allocate_limit_baromoney`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            modelValue: _ctx.formattedAllocateLimitBaromoneyComputed,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.formattedAllocateLimitBaromoneyComputed) = $event)),
                            density: "compact",
                            variant: "outlined",
                            inputmode: "numeric",
                            "hide-details": "auto",
                            suffix: _ctx.$t('common.currency'),
                            maxlength: _ctx.allocateLimitBaromoneyMaxLength,
                            "validate-on": "blur",
                            oninput: "javascript: this.value = this.value.replace(/[^-?0-9]|[-]{2,}|-0|\\d{1}-\\d{1}/g, '' );",
                            onBlur: _cache[6] || (_cache[6] = ($event) => (_ctx.onBlurAllocateLimitBaromoneyField(_ctx.formattedAllocateLimitBaromoneyComputed)))
                        }, null, 8 /* PROPS */, ["modelValue", "suffix", "maxlength"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 최대 배차 가능 건수 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}max_allocate_count`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            modelValue: _ctx.formattedMaxAllocateCountComputed,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.formattedMaxAllocateCountComputed) = $event)),
                            density: "compact",
                            variant: "outlined",
                            inputmode: "numeric",
                            "hide-details": "auto",
                            suffix: _ctx.$t('common.count'),
                            maxlength: _ctx.MAX_ALLOCATE_COUNT_LENGTH,
                            "validate-on": "blur",
                            oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                            onBlur: _cache[8] || (_cache[8] = ($event) => (_ctx.onBlurMaxAllocateCountField(_ctx.formattedMaxAllocateCountComputed)))
                        }, null, 8 /* PROPS */, ["modelValue", "suffix", "maxlength"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 배차 후 완료가능 최소시간 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}min_finish_minute_after_allocated`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            modelValue: _ctx.formattedMinFinishMinuteAfterAllocatedComputed,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.formattedMinFinishMinuteAfterAllocatedComputed) = $event)),
                            density: "compact",
                            variant: "outlined",
                            inputmode: "numeric",
                            "hide-details": "auto",
                            suffix: _ctx.$t('common.minutes'),
                            maxlength: _ctx.MIN_FINISH_MINUTE_AFTER_ALLOCATED_LENGTH,
                            rules: _ctx.formRules.minFinishMinuteAfterAllocated.value,
                            "validate-on": "blur",
                            oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                            onBlur: _cache[10] || (_cache[10] = ($event) => (_ctx.onBlurMinFinishMinuteAfterAllocatedField(_ctx.formattedMinFinishMinuteAfterAllocatedComputed)))
                        }, null, 8 /* PROPS */, ["modelValue", "suffix", "maxlength", "rules"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" GPS 활성화 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}is_gps_on`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: _ctx.isForceGpsOnComputed,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.isForceGpsOnComputed) = $event)),
                            name: "radio",
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredOptions, (option, key) => {
                                    return (_openBlock(), _createBlock(_component_v_radio, {
                                        key: key,
                                        label: option.label,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 공유배달 버튼 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}is_share_order_hidden`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: _ctx.isSharedOrderHiddenComputed,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.isSharedOrderHiddenComputed) = $event)),
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exposureOptions, (option, key) => {
                                    return (_openBlock(), _createBlock(_component_v_radio, {
                                        key: key,
                                        label: option.label,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 배차취소 권한 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}right_to_cancel_allocate`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: _ctx.isPossibleToCancelAllocatedOrderComputed,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.isPossibleToCancelAllocatedOrderComputed) = $event)),
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilityOptions, (option, key) => {
                                    return (_openBlock(), _createBlock(_component_v_radio, {
                                        key: key,
                                        label: option.label,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 픽업예상시간 수정 권한 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}right_to_calcel_allocated_order`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: _ctx.isImpossibleToChangePickupExpectedAtComputed,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.isImpossibleToChangePickupExpectedAtComputed) = $event)),
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilityOptions, (option, key) => {
                                    return (_openBlock(), _createBlock(_component_v_radio, {
                                        key: key,
                                        label: option.label,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 도착지 주소 수정 권한 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}right_to_change_drop_address`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: _ctx.isPossibleToChangeDropAddressComputed,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.isPossibleToChangeDropAddressComputed) = $event)),
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availabilityOptions, (option, key) => {
                                    return (_openBlock(), _createBlock(_component_v_radio, {
                                        key: key,
                                        label: option.label,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 결제수단 변경 권한 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}right_to_change_payment_authority_type`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: _ctx.changePaymentAuthorityTypeComputed,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.changePaymentAuthorityTypeComputed) = $event)),
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorityOptions, (option, key) => {
                                    return (_openBlock(), _createBlock(_component_v_radio, {
                                        key: key,
                                        label: option.label,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 라이더 수수료 그룹 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}worker_delivery_fee_group`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createVNode(_component_v_text_field, {
                                modelValue: _ctx.workerDeliveryFeeGroupName,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.workerDeliveryFeeGroupName) = $event)),
                                filled: "",
                                disabled: "",
                                variant: "outlined",
                                density: "compact",
                                placeholder: _ctx.$t(`${_ctx.lc}default_group_in_hub`),
                                "hide-details": "auto",
                                class: "grow"
                            }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
                            _createVNode(_component_DeliveryFeeGroupSelect, { onOnApply: _ctx.handleClickWorkerDeliveryFeeGroupSelect }, null, 8 /* PROPS */, ["onOnApply"])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 자동 차감 그룹 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}cash_auto_deduct_group`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_v_text_field, {
                                modelValue: _ctx.workerCashAutoDeductGroupName,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.workerCashAutoDeductGroupName) = $event)),
                                filled: "",
                                disabled: "",
                                variant: "outlined",
                                density: "compact",
                                placeholder: _ctx.$t(`${_ctx.lc}default_group_in_hub`),
                                "hide-details": "auto",
                                class: "grow"
                            }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
                            _createVNode(_component_CashAutoDeductGroupSelect, { onOnApply: _ctx.handleClickWorkerCashAutoDeductGroupSelect }, null, 8 /* PROPS */, ["onOnApply"])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 배차취소 패널티 그룹 "),
                _createVNode(_component_InputRow, {
                    label: _ctx.$t(`${_ctx.lc}allocated_cancel_penalty_group`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_v_text_field, {
                                modelValue: _ctx.workerPenaltyGroupName,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.workerPenaltyGroupName) = $event)),
                                filled: "",
                                disabled: "",
                                variant: "outlined",
                                density: "compact",
                                placeholder: _ctx.$t(`${_ctx.lc}default_group_in_hub`),
                                "hide-details": "auto",
                                class: "grow"
                            }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
                            _createVNode(_component_AllocatedCancelPenaltyGroupSelect, { onOnApply: _ctx.handleClickWorkerPenaltyGroupSelect }, null, 8 /* PROPS */, ["onOnApply"])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title"])
    ]));
}
